<template>
  <div id="impor-page">
    <h6 class="m-t-0 m-b-20">
      <i class="bi bi-download"></i> Impor Data
      <i
        class="bi bi-question-circle text-blue"
        v-tooltip.right="{ ref: 'imporHelper' }"
      ></i>
    </h6>
    <div ref="imporHelper" class="tooltip-content">
      <p>
        <b>Impor Data</b>. Anda dapat mengupload file excel yang berisi data
        grup, topik, dan keyword untuk mempercepat proses input.
      </p>
    </div>
    <div v-if="is_error" class="alert alert-warning">
      <div
        class="d-flex align-items-center clickable hoverable"
        @click="is_view_detail = !is_view_detail"
      >
        <i class="bi bi-x-circle mr-1"></i>
        Perhatian! Terdapat beberapa kesalahan import
        <i
          class="bi  ml-auto"
          :class="is_view_detail ? 'bi-caret-down-fill' : 'bi-caret-right-fill'"
        ></i>
      </div>
      <div v-if="is_view_detail" class="mt-2">
        <div
          v-for="(item, index) in error_data"
          :key="index"
          class="d-flex align-items-center"
        >
          <div style="width: 20px;">{{ index + 1 }}.</div>
          {{ item }}
        </div>
      </div>
    </div>
    <form action="#" @submit.prevent="submitForm">
      <div class="row" style="margin-left: 2px;">
        <div class="col-4">
          <input
            type="file"
            name="file"
            @change="previewFile"
            id="inputFile"
            class="form-control"
            required
          />
        </div>
        <div class="col-2 p-l-5">
          <button class="btn btn-success btn-icon-left h-100" type="submit">
            <i class="bi bi-upload"></i> <span>Upload</span>
          </button>
        </div>
      </div>
    </form>
    <p class="m-t-20">
      Download format excel untuk impor
      <a href="/assets/files/Format Default Import Keyword V3.xlsx">disini</a>
    </p>
    <floating-loader-component
      key="loading_key"
      v-if="is_loading"
      :text="loading_text"
    />
  </div>
</template>

<script>
import floating_loader from "@/views/components/floating_loader.vue";
import notif from "@/assets/js/notif.js";

export default {
  name: "tab_impor_ekspor",
  components: {
    "floating-loader-component": floating_loader,
  },
  data() {
    return {
      file_input: null,
      img_path: null,
      id_project: this.$route.query.ref
        ? atob(this.$route.query.ref)
        : this.$store.getters.user.id_project,
      loading_text: null,
      loading_key: 0,
      is_loading: false,
      validation_medkon: [],
      validation_medsos: [],
      is_error: false,
      is_view_detail: false,
    };
  },
  methods: {
    previewFile: function(e) {
      let file = e.target.files[0];
      this.file_input = file;
    },
    submitForm: function() {
      this.is_error = false;
      this.is_view_detail = false;
      this.validation_medkon = [];
      this.validation_medsos = [];
      this.$.pgNotification = notif;

      let formData = new FormData();
      formData.append("file", this.file_input);
      formData.append("id_project", this.id_project);

      if (this.file_input != null) {
        this.is_loading = true;
        this.loading_text = "Memproses data...";
        this.loading_key++;

        let api = process.env.VUE_APP_API_URL + "import-keyword-excel";
        this.$http
          .post(api, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            if (response.status == 200) {
              if ("validation_medkon" in response.data) {
                this.validation_medkon = response.data.validation_medkon;
              }
              if ("validation_medsos" in response.data) {
                this.validation_medsos = response.data.validation_medsos;
              }
              if (
                this.validation_medkon.length == 0 &&
                this.validation_medsos.length == 0
              ) {
                this.$("body")
                  .pgNotification({
                    style: "bar",
                    message:
                      '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Data berhasil diimpor!',
                    position: "top-right",
                    timeout: 5000,
                    type: "success",
                  })
                  .show();
              } else {
                this.is_error = true;
              }
            } else {
              this.$("body")
                .pgNotification({
                  style: "bar",
                  message:
                    '<i class="bi bi-x-circle"></i> <b>Error!</b> Terjadi kesalahan pada saat mengimpor data!',
                  position: "top-right",
                  timeout: 4000,
                  type: "danger",
                })
                .show();
            }
          })
          .catch((error) => {
            console.log(error);
            this.$("body")
              .pgNotification({
                style: "bar",
                message:
                  '<i class="bi bi-x-circle"></i> <b>Error!</b> Terjadi kesalahan pada saat mengimpor data!',
                position: "top-right",
                timeout: 5000,
                type: "danger",
              })
              .show();
          })
          .finally(() => {
            this.is_loading = false;
          });
      }
    },
  },
  computed: {
    error_data() {
      const data = [...this.validation_medkon, ...this.validation_medsos];
      return data;
    },
  },
};
</script>
